import { render } from "./Aeroporto.vue?vue&type=template&id=54f050a4&scoped=true"
import script from "./Aeroporto.vue?vue&type=script&lang=js"
export * from "./Aeroporto.vue?vue&type=script&lang=js"

import "./Aeroporto.vue?vue&type=style&index=0&id=54f050a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f050a4"]])

export default __exports__